import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import BackButton from '../BackButton'
import { SectionItem } from '../Section'
import { makeDefaultFailedContainer } from 'components/container'
import WelcomeMessageBuilder from 'components/shared/MessagePreviews/WelcomeMessage'
import { getChanges } from 'components/Customize/OrgSettings/Helpers'
import { List } from 'immutable'
import ColorPicker from 'components/Customize/Styling/ColorPicker'
import IconPicker from 'components/Customize/Styling/IconPicker'
import CustomIconPicker from 'components/Customize/Styling/CustomIconPicker'
import FontPicker from 'components/Customize/Styling/FontPicker'
import WidgetSizePicker from 'components/Customize/Styling/WidgetSizePicker'
import DriftBranding from 'components/Customize/Styling/DriftBranding'
import UISelect from 'components/shared/UISelect'
import MessengerBuilder from '../MessengerBuilder'
import { LOCALE_OPTIONS } from 'components/I18n/Constants'
import { IconPickerConfig, IconStyles, IconTypes } from 'components/Customize/Styling/IconPicker/Constants'
import IconSVG from 'svg-inline-react'
import PageTitle from '../PageTitle'
import { Icon, InlineWarning } from '@driftt/tide-core-legacy'

import { botUser } from 'app/modules/user/selectors'

import style from './style.styl'

const DELAY_IN_MS = 1000
const NOTIFICATION_MESSAGE = 'The style of your Drift Widget has been updated!'
const sendIconSvg = require('!svg-inline?removeTags=true&removeSVGTagAttrs=false!images/svg/paper-plane-solid.svg')

const tryTrimValue = value => {
  return typeof value === 'string' ? value.trim() : value
}

const ICON_PICKER_CHAT_SRC_CONFIG = {
  [IconStyles.SOLID1]: {
    [IconTypes.chatSrc]: IconPickerConfig[IconStyles.SOLID1][IconTypes.chatSrc],
  },
  [IconStyles.SOLID2]: {
    [IconTypes.chatSrc]: IconPickerConfig[IconStyles.SOLID2][IconTypes.chatSrc],
  },
  [IconStyles.OUTLINE1]: {
    [IconTypes.chatSrc]: IconPickerConfig[IconStyles.OUTLINE1][IconTypes.chatSrc],
  },
  [IconStyles.OUTLINE2]: {
    [IconTypes.chatSrc]: IconPickerConfig[IconStyles.OUTLINE2][IconTypes.chatSrc],
  },
}

const ButtonsDescription = () => (
  <div className="buttons-description">
    <span>You can make the Drift Widget open when somebody clicks on a button or link. </span>
    <a
      href="https://help.drift.com/article/changing-the-drift-icon-to-a-logo-face-or-custom-image/"
      target="_blank"
    >
      {`Here's how.`}
    </a>
  </div>
)

export class ChatWidgetDesign extends Component {
  static contextTypes = {
    app: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.handleThemeChange = this.handleThemeChange.bind(this)
    this.submitThemeChangeForManualSave = this.submitThemeChangeForManualSave.bind(this)
    this.onChangeThemeColor = this.onChangeThemeColor.bind(this)
    this.colorsHaveChanged = this.colorsHaveChanged.bind(this)
    this.revertToOriginalColorScheme = this.revertToOriginalColorScheme.bind(this)
    this.handleCustomIconChange = this.handleCustomIconChange.bind(this)
    this.handleClearIcon = this.handleClearIcon.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.handleToggleBranding = this.handleToggleBranding.bind(this)
    this.patchOrgSettingsDebounced = _.debounce(this.patchOrgSettings, DELAY_IN_MS)

    this.state = {
      theme: props.orgSettings.theme,
      tmpColors: {
        backgroundColor: props.orgSettings.theme.backgroundColor,
        foregroundColor: props.orgSettings.theme.foregroundColor,
        textColor: props.orgSettings.theme.textColor,
        activeColor: props.orgSettings.theme.activeColor,
        widgetBackgroundColor: props.orgSettings.theme.widgetBackgroundColor
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const hasChanged = !nextProps.orgSettings.theme.equals(this.props.orgSettings.theme)

    if (hasChanged) {
      this.setState({ theme: nextProps.orgSettings.theme })
    }
  }

  handleThemeChange(key) {
    return (value, isValid) => {
      const { theme } = this.state
      const themePropertyName = key[1]
      const updatedTheme = theme.merge({ [themePropertyName]: tryTrimValue(value) })
      this.setState({ theme: updatedTheme })

      if (themePropertyName === 'activeColor') {
        if (isValid && value.toLowerCase() !== 'ffffff') {
          const { orgSettings } = this.props
          const updatedOrgSettings = orgSettings.merge({ theme: updatedTheme })
          this.patchOrgSettingsDebounced(updatedOrgSettings, orgSettings)
        }
      } else {
        if (isValid) {
          const { orgSettings } = this.props
          const updatedOrgSettings = orgSettings.merge({ theme: updatedTheme })
          this.patchOrgSettingsDebounced(updatedOrgSettings, orgSettings)
        }
      }
    }
  }

  submitThemeChangeForManualSave() {
    const { theme, tmpColors } = this.state
    const updatedTheme = theme.merge(tmpColors)
    this.setState({ theme: updatedTheme })

    const { orgSettings } = this.props
    const updatedOrgSettings = orgSettings.merge({ theme: updatedTheme })
    this.patchOrgSettings(updatedOrgSettings, orgSettings)
  }

  onChangeThemeColor(key, hex) {
    this.setState({
      tmpColors: {
        ...this.state.tmpColors,
        [key]: hex
      }
    })
  }

  colorsHaveChanged() {
    const { theme, tmpColors } = this.state
    return Object.keys(tmpColors).some(key => theme[key].toLowerCase() !== tmpColors[key].toLowerCase())
  }

revertToOriginalColorScheme() {
  this.setState({
    tmpColors: {
      backgroundColor: this.props.orgSettings.theme.backgroundColor,
      foregroundColor: this.props.orgSettings.theme.foregroundColor,
      textColor: this.props.orgSettings.theme.textColor,
      activeColor: this.props.orgSettings.theme.activeColor,
      widgetBackgroundColor: this.props.orgSettings.theme.widgetBackgroundColor
    }
  })
}


  handleCustomIconChange([icon]) {
    const { embed, orgSettings } = this.props
    const { actions } = this.context.app

    const iconUrl = () => this.state.theme.iconUrl

    const patchChanged = () => {
      const updatedOrgSettings = orgSettings.setIn(['theme', 'iconUrl'], iconUrl())
      this.patchOrgSettings(updatedOrgSettings, orgSettings)
    }

    actions.OrgSettingsActions.updateIcon(embed.orgId, icon).then(patchChanged)
  }

  handleClearIcon() {
    const { orgSettings } = this.props
    const updatedOrgSettings = orgSettings.setIn(['theme', 'iconUrl'], null)

    this.setState({ theme: updatedOrgSettings.theme })
    this.patchOrgSettings(updatedOrgSettings, orgSettings)
  }

  handleSelectChange(key) {
    return ({ value }) => {
      const { orgSettings } = this.props
      const updatedOrgSettings = orgSettings.setIn(key, value)

      this.updateOrgSettings(updatedOrgSettings)
      this.patchOrgSettings(updatedOrgSettings, orgSettings)
    }
  }

  handleToggleBranding(event) {
    const { orgSettings } = this.props
    const showBranding = event.target.checked
    const updatedOrgSettings = orgSettings.merge({ showBranding })

    this.updateOrgSettings(updatedOrgSettings)
    this.patchOrgSettings(updatedOrgSettings, orgSettings)
  }

  updateOrgSettings(updatedOrgSettings) {
    const { actions } = this.context.app
    actions.OrgSettingsActions.updateOrgSettings(updatedOrgSettings)
  }

  patchOrgSettings(updatedOrgSettings, orgSettings) {
    const changes = getChanges(updatedOrgSettings, orgSettings)

    const { actions } = this.context.app
    actions.DefaultEmbedActions.patchDefaultEmbed(changes, NOTIFICATION_MESSAGE)
  }

  render() {
    const { currentUser, botUser, orgSettings } = this.props
    const { theme, tmpColors } = this.state

    const name = currentUser.name || orgSettings.orgName

    const hasBotInfo = botUser && botUser.get('name') && botUser.get('avatarUrl')

    return (
      <div className={style.ChatWidgetDesign}>
        <BackButton title="Drift Widget Settings" url="/settings/widget" />

        <PageTitle
          title="Design"
          description="Stylize your design elements"
          className="design-settings-page-title"
        />
        <h3 className="widget-settings-section-header-title">Widget Style - Colors, Icon and Font</h3>
        <span className="widget-settings-section-header-desc">
          These colors are also used in playbooks and emails.{' '}
          <a href="https://help.drift.com/article/customizing-your-drift-colors/" target="_blank">
            Learn More.
          </a>
        </span>
        <div className="widget-settings-protip info-container">
          <Icon className="widget-icon info-icon" name="info" />
          <div className="widget-settings-info-text">
            Pro Tip: To satisfy web accessibility requirements, ensure that there is at least a
            <a href="https://webaim.org/resources/contrastchecker/" target="_blank">
              {' '}
              3:1 contrast ratio{' '}
            </a>
            between all combinations of foreground and background colors.
          </div>
        </div>
        <div className="top-container">
          <div className="welcome-message-container" style={{ fontFamily: theme.fontFamily }}>
            <WelcomeMessageBuilder
              backgroundColor={tmpColors.backgroundColor}
              foregroundColor={tmpColors.foregroundColor}
              showProfileIcon={true}
              users={List.of(currentUser)}
              title={<span>{name}</span>}
              message={theme.welcomeMessage}
            >
              <div className="composer" style={{backgroundColor: tmpColors.widgetBackgroundColor}}>
                <div className="composer-prompt">Type your message…</div>
                <div className="composer-input">Hey |</div>
                <div className="composer-actions" style={{ color: tmpColors.activeColor }}>
                  <IconSVG src={sendIconSvg} style={{ color: tmpColors.activeColor }} />
                  Send Message
                </div>
              </div>
            </WelcomeMessageBuilder>

            <MessengerBuilder
              themeColors={tmpColors}
              avatarUrl={hasBotInfo ? botUser.get('avatarUrl') : currentUser.avatarUrl}
              name={hasBotInfo ? botUser.get('name') : name}
            />
          </div>

          <div className="color-scheme">
            <div className="color-picker">
              <ColorPicker
                colors={tmpColors}
                onChange={this.onChangeThemeColor}
                onSubmit={this.submitThemeChangeForManualSave}
                onCancel={this.revertToOriginalColorScheme}
                hasChanged={this.colorsHaveChanged}
              />
            </div>
          </div>
        </div>

        <div className="buttons">
          <div className="icon-container">
            <div className="icon-picker">
              <IconPicker
                selectedIconStyle={theme.iconStyle}
                foregroundColor={theme.foregroundColor}
                backgroundColor={theme.backgroundColor}
                onSelection={this.handleThemeChange(['theme', 'iconStyle'])}
                iconPickerConfig={ICON_PICKER_CHAT_SRC_CONFIG}
              />
            </div>
            <div className="icon-uploader">
              <CustomIconPicker
                onDrop={this.handleCustomIconChange}
                onClear={this.handleClearIcon}
                preview={theme.iconUrl}
                iconStyle={theme.iconStyle}
              />
            </div>
          </div>
          <div className="buttons-info">
            <SectionItem title="Want to use your own button?" description={<ButtonsDescription />} />
          </div>
        </div>

        <div className="dropdowns">
          <div className="typeface-dropdown">
            <span className="label">Widget Font</span>
            <FontPicker
              fontFamily={theme.fontFamily}
              onSelection={this.handleSelectChange(['theme', 'fontFamily'])}
            />
          </div>
          <div className="language-dropdown">
            <span className="label">Language</span>
            <UISelect
              value={orgSettings.locale}
              options={LOCALE_OPTIONS}
              onSelection={this.handleSelectChange(['locale'])}
            />
          </div>
        </div>
        <div className="widget-size">
          <h3 className="widget-settings-section-header-title">Widget Size</h3>
          <span className="widget-settings-section-header-desc">
            Choose how Drift Widget is displayed on your website.
          </span>
          <WidgetSizePicker
            widgetHalfHeight={theme.widgetHalfHeight}
            onSelection={this.handleThemeChange(['theme', 'widgetHalfHeight'])}
          />
        </div>

        <div className="drift-branding">
          <DriftBranding value={orgSettings.showBranding} onChange={this.handleToggleBranding} />
        </div>
      </div>
    )
  }
}

const ChatWidgetDesignContainer = makeDefaultFailedContainer(ChatWidgetDesign, {
  listenTo: ['stores.OrgSettingsStore', 'stores.UserStore', 'stores.DefaultEmbedStore'],
  fetch: {
    orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings()
    },
    currentUser() {
      return this.app.stores.UserStore.getOrFetchCurrentUser()
    },
    embed() {
      return this.app.stores.DefaultEmbedStore.getOrFetchCurrentDefaultEmbed()
    },
  },
})

const mapStateToProps = state => ({
  botUser: botUser(state),
})

export default connect(mapStateToProps)(ChatWidgetDesignContainer)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/Design/index.js